module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 116
// module chunks = 35783957827783 212839066777427 263063586409284